<template>
  <div class="container pt-2">
    <div class="ranks-chart-criteria">
      <div class="ranks-chart-criteria-row">
        <label for="ranksNeedsMetricsPrimaryAxis" class="ranks-chart-criteria-label">Primary Axis</label>
        <select
          id="ranksNeedsMetricsPrimaryAxis"
          class="custom-select shadow ranks-chart-criteria-select"
          :disabled="disabled || primaryAxisOptions.length === 0"
          :value="selectedPrimaryAxis"
          @change="$emit('update-primary-axis', $event.target.value)"
        >
          <option value="">Select</option>
          <option v-for="option in primaryAxisOptions" :key="option.value" :value="option.value">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="ranks-chart-criteria-row">
        <label for="ranksNeedsMetricsSecondaryAxis" class="ranks-chart-criteria-label">Secondary Axis</label>
        <select
          id="ranksNeedsMetricsSecondaryAxis"
          class="custom-select shadow ranks-chart-criteria-select"
          :disabled="disabled || secondaryAxisOptions.length === 0"
          :value="selectedSecondaryAxis"
          @change="$emit('update-secondary-axis', $event.target.value)"
        >
          <option value="">None</option>
          <option v-for="option in secondaryAxisOptions" :key="option.value" :value="option.value">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="ranks-chart-criteria-actions">
        <button type="button" class="btn btn-primary mr-2" :disabled="disabled || selectedPrimaryAxis === ''" @click="$emit('draw')">Draw</button>
        <button type="button" class="btn btn-primary mr-2" :disabled="disabled" @click="$emit('reset')">Reset</button>
        <button type="button" class="btn btn-primary" :disabled="disabled || !canSave" @click="$emit('save-card')">Save as Card</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RanksChartCriteria",
  methods: {
    loadCriteriaData(criteria) {
      if (typeof criteria == "undefined" || criteria == null || criteria == "") {
        return;
      }
      let params = criteria instanceof URLSearchParams ? criteria : new URLSearchParams(criteria);
      let primaryAxis = params.get("primaryAxis") || "";
      let secondaryAxis = params.get("secondaryAxis") || "";
      if (primaryAxis == "") {
        return;
      }
      this.$emit("update-primary-axis", primaryAxis);
      this.$emit("update-secondary-axis", secondaryAxis);
      this.$emit('draw');
/*      
      this.$nextTick(() => {
        this.$emit("draw");
      });
*/      
    }
  },
  props: {
    primaryAxisOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    secondaryAxisOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    selectedPrimaryAxis: {
      type: String,
      default: ""
    },
    selectedSecondaryAxis: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canSave: {
      type: Boolean,
      default: false
    }
  }
};
</script>
